import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { SupportSheet } from "../../components/SupportSheet";
import { SEND_ROUTES } from "../../constants";
import { HomePage } from "./HomePage";

export const SupportPage = memo(() => {
  const navigate = useNavigate();

  return (
    <>
      <HomePage />
      <SupportSheet
        namespace="send"
        visible
        onClose={() => navigate(SEND_ROUTES.HOME)}
      />
    </>
  );
});
